import dwhExport from '~/dwhExport'
import PropTypes from "prop-types";
import * as React from "react";
import { translate } from "react-i18next";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import classNames from "classnames";
import { scrollToY } from "helpers/animate";
import { getElementOffsetTop } from "helpers/position";
import { t } from "helpers/localization";
import { hasAnyPermission, permissions, roleNames } from "roles";
import settings from "settings";
import styles from "./Members.scss";
import { MembersTable, BattleSelector, Ratings, MembersControlBlock, LadderSeasonsDropdown, LadderTeamsDropdown } from "../UIKit/UIKit";
import Sticky from "../UIKit/Sticky/Sticky";
import { StickyContainer, StepCSSTransitionGroup, Toggle } from "@wg/wows-react-uikit";
import { isClanBattleType } from "helpers/ladder";
import { BATTLE_TYPES } from "constants";

const propTypes = {
  currentAccount: PropTypes.shape({
    id: PropTypes.number.isRequired,
    clanId: PropTypes.number,
    roleName: PropTypes.oneOf(roleNames)
  }).isRequired,

  selectedMemberIds: PropTypes.arrayOf(PropTypes.number),
  onRemoveMembersClick: PropTypes.func.isRequired,
  onChangeCommanderClick: PropTypes.func.isRequired,
  onChangeRoleClick: PropTypes.func.isRequired,
  onMembersReloadClick: PropTypes.func.isRequired,
  openAccountProfile: PropTypes.func.isRequired,
  openChatWindow: PropTypes.func.isRequired,
  onTickMember: PropTypes.func.isRequired,
  onTickAllMembers: PropTypes.func.isRequired,

  isMissingStatistics: PropTypes.bool,
  isHiddenStatistics: PropTypes.bool,
  statistics: PropTypes.shape({
    totalMembers: PropTypes.number,
    maxMembersCount: PropTypes.number,
    averageBattlesCounts: PropTypes.number,
    averageWinsPercentage: PropTypes.number,
    averageExperiencePerBattle: PropTypes.number,
    averageDamagePerBattle: PropTypes.number,
    currentBattleType: PropTypes.string,
    ladderWinsCount: PropTypes.number
  }),
  sort: PropTypes.shape({
    field: PropTypes.string.isRequired,
    isAsc: PropTypes.bool.isRequired
  }),
  currentSeasonType: PropTypes.string,
  currentSeason: PropTypes.number,
  onSeasonChange: PropTypes.func.isRequired,
  onThSortClick: PropTypes.func.isRequired,
  onBattleTypeChange: PropTypes.func.isRequired,
  onTeamNumberChange: PropTypes.func.isRequired,
  selectedBattleType: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired,
  clan: PropTypes.shape({
    id: PropTypes.number,
    tag: PropTypes.string,
    name: PropTypes.string,
    leveling: PropTypes.number,
    rawDescription: PropTypes.string,
    color: PropTypes.string,
    error: PropTypes.string,
    createdAt: PropTypes.string,

    accumulativeResource: PropTypes.number,
    personalResource: PropTypes.number,
    isPreloadedData: PropTypes.bool
  }),
  clanId: PropTypes.number,

  onRender: PropTypes.func.isRequired,

  disabledIds: PropTypes.array.isRequired,
  isFetchingMembers: PropTypes.bool,
  membersError: PropTypes.string
};

class Members extends React.Component {

  static defaultProps = {
    selectedBattleType: settings.defaultBattleType
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.currentAccount.clanId === this.props.clanId && !this.props.isFromSearch) {
      dwhExport.send('members.open_page')
    }
    const clanId = this.props.clanId;
    if (clanId) {
      this.props.onRender(clanId);
    }
  }
  onThSortClick = (field, isAsc, hiddenSortingNames) => {
    this.props.onThSortClick(field, isAsc, hiddenSortingNames, this.props.clanId);
  };

  onBattleTypeChange = selectedBattleType => {
    if (this.props.currentAccount.clanId === this.props.clanId) {
      let battleTypeForDwh = selectedBattleType
      if (selectedBattleType === "pve") {
          battleTypeForDwh = "coop"
      }
      dwhExport.send('members.select_battle_type', {
          battle_type: battleTypeForDwh
      })
    }
    this.props.onBattleTypeChange(selectedBattleType, this.props.clanId);
  };

  onTeamNumberChange = selectedTeamnumber => {
    if (this.props.currentAccount.clanId === this.props.clanId) {
      dwhExport.send('members.select_team_number', {
          teamNumber: selectedTeamnumber
      })
    }
    this.props.onTeamNumberChange(selectedTeamnumber, this.props.clanId);
  };

  onMembersReloadClick = () => {
    this.props.onMembersReloadClick(this.props.clanId);
  };

  scrollToOwn(event) {
    event.preventDefault();
    const ownScrollEl = document.getElementById('ownScrollId');
    const appContainerEl = document.getElementById('app-container');
    const appEl = document.getElementById('app');
    const scrollTo = getElementOffsetTop(ownScrollEl) - getElementOffsetTop(appEl) - // position of ownScrollEl relative to appEl
      appContainerEl.offsetHeight / 2 - ownScrollEl.offsetHeight / 2 // shift ownScrollEl to the middle of a viewport (appContainerEl)
      ;
    scrollToY(appEl, scrollTo);
  }

  onRemoveMembersClick = () => {
    this.props.onRemoveMembersClick(this.props.members.filter(m => this.props.selectedMemberIds.includes(m.id)));
  };

  onChangeCommanderClick = () => {
    if (this.props.selectedMemberIds.length === 1) {
      this.props.onChangeCommanderClick(this.props.members.find(m => m.id === this.props.selectedMemberIds[0]));
    }
  };

  onSeasonChange = season => {
    if (this.props.currentAccount.clanId === this.props.clanId) {
      dwhExport.send('members.select_season', {
          season: season
      })
    }
    this.props.onSeasonChange(season, this.props.clanId);
  };

  renderTeamsMenu() {
    return <div className={styles.seasonsMenu}>
    <LadderTeamsDropdown selectedTeamNumber = {this.props.selectedTeamNumber} season={this.props.currentSeason} statistics = {this.props.statistics} onTeamNumberChange = {this.onTeamNumberChange} />
  </div>;
  }

  renderSeasonsMenu() {
    if (isNull(this.props.currentSeason)) return null;

    return <div className={styles.seasonsMenu}>
      <LadderSeasonsDropdown selectedSeasonId={this.props.currentSeason} selectedSeasonType={this.props.currentSeasonType} onSeasonChange={this.onSeasonChange} dropdownPosition="bottom" />
    </div>;
  }

  hasAnyClanManagementPermissions() {
    return hasAnyPermission(this.props.currentAccount.roleName, [permissions.CHANGE_ROLE, permissions.CHANGE_COMMANDER, permissions.REMOVE_MEMBER]);
  }

  renderMembersControlBlock() {
    let membersControlBlock = null;
    if (this.hasAnyClanManagementPermissions() && !this.props.membersError) {
      membersControlBlock = <Sticky usedStickyContainerId="members-table-control-block-sticky-container" isActive={this.props.selectedMemberIds.length > 0} forBottom>
        <div className={styles.membersControlBlock}>
          <MembersControlBlock clanId={this.props.clanId} isDisabled={this.props.isFetchingMembers} roleName={this.props.currentAccount.roleName} selectedMembersLength={this.props.selectedMemberIds.length} onRemoveMembersClick={this.onRemoveMembersClick} onChangeCommanderClick={this.onChangeCommanderClick} onChangeRoleClick={this.props.onChangeRoleClick} t={t} />
        </div>
      </Sticky>;
    }

    return membersControlBlock;
  }

  renderMembersTable() {
    if (isUndefined(this.props.isFetchingMembers) || this.props.isFetchingMembers) return null;

    let ownScroll = null;

    if (this.props.membersError) {
      ownScroll = <div className={styles.ownScrollEmpty} />;
    } else {
      const classNameOwnScroll = classNames(styles.ownScroll, {
        [styles.isDisabled]: this.props.isFetchingMembers
      });

      ownScroll = <div key="own-scroll" className={classNameOwnScroll}>
        <Toggle caption={t('Перейти к моей позиции')} onClick={this.scrollToOwn} />
      </div>;
    }

    return this.props.currentAccount.clanId === this.props.clanId ? <StepCSSTransitionGroup level={3}>
      <StickyContainer key="members-table" id="members-table-control-block-sticky-container">
        {ownScroll}
        <MembersTable clanId={this.props.clanId} currentAccount={this.props.currentAccount} disabledIds={this.props.disabledIds} error={this.props.membersError} members={this.props.members} selectedMemberIds={this.props.selectedMemberIds} sort={this.props.sort} displayCheckboxes={this.hasAnyClanManagementPermissions()} isContextMenuEnabled isFetching={this.props.isFetchingMembers} currentBattleType={this.props.statistics ? this.props.statistics.currentBattleType : ''} stickyContainerId="members-table-sticky-container" onChangeCommanderClick={this.props.onChangeCommanderClick} onChangeRoleClick={this.props.onChangeRoleClick} onReloadClick={this.onMembersReloadClick} onRemoveMembersClick={this.props.onRemoveMembersClick} onThSortClick={this.onThSortClick} onTickAllMembers={this.props.onTickAllMembers} onTickMember={this.props.onTickMember} openAccountProfile={this.props.openAccountProfile} openChatWindow={this.props.openChatWindow} />
        {this.renderMembersControlBlock()}
      </StickyContainer>
    </StepCSSTransitionGroup> : <StepCSSTransitionGroup level={3}>
        <StickyContainer key="members-table" id="members-table-control-block-sticky-container">
          <MembersTable key="members-table" clanId={this.props.clanId} currentAccount={this.props.currentAccount} error={this.props.membersError} members={this.props.members} sort={this.props.sort} isFetching={this.props.isFetchingMembers} currentBattleType={this.props.statistics ? this.props.statistics.currentBattleType : ''} stickyContainerId="members-table-sticky-container" onReloadClick={this.props.onMembersReloadClick} onThSortClick={this.props.onThSortClick} openAccountProfile={this.props.openAccountProfile} openChatWindow={this.props.openChatWindow} />
        </StickyContainer>
      </StepCSSTransitionGroup>;
  }

  render() {
    const battleTypes = [];

    settings.battleTypes.forEach(e => {
      battleTypes.push(e);
    });

    return <div className={styles.container}>
      <div id="profileRatingsScrollId" className={styles.profileRatings} ref={c => this._profileRatings = c}>
        <StepCSSTransitionGroup level={1}>
          <div className={styles.battleSelectorWrap}>
            <BattleSelector key="battle-selector" items={battleTypes} selected={this.props.selectedBattleType} onBattleTypeChange={this.onBattleTypeChange} />
          </div>
          {isClanBattleType(this.props.selectedBattleType) ? this.renderSeasonsMenu() : null}
          {isClanBattleType(this.props.selectedBattleType) ? this.renderTeamsMenu() : null}
        </StepCSSTransitionGroup>
        {!this.props.isFetchingMembers && <StepCSSTransitionGroup level={2}>
          <Ratings key="ratings" clanId={this.props.clanId} currentSeason={this.props.currentSeason} membersError={!!this.props.membersError || this.props.isMissingStatistics} statistics={this.props.statistics} isHiddenStatistics={this.props.isHiddenStatistics} />
        </StepCSSTransitionGroup>}
      </div>
      {this.renderMembersTable()}
    </div>;
  }
}

Members.propTypes = propTypes;

export default translate()(Members);